import { forwardRef } from 'react';
import { ConversationMessageDto } from '@endion/types';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { nanoid } from 'nanoid';

type ChatInputFormProps = {
  input: string;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  append: (message: ConversationMessageDto) => Promise<void>;
  isLoading: boolean;
  error: string | null;
  setInput: (input: string) => void;
};

export const ChatInputForm = forwardRef<HTMLInputElement, ChatInputFormProps>(
  (
    { input, handleInputChange, append, isLoading, error, setInput }: ChatInputFormProps,
    ref: React.Ref<HTMLInputElement>,
  ) => {
    function submitMessage(e: React.BaseSyntheticEvent) {
      e.preventDefault(); // Prevent submitting the form
      if (!input) return; // Prevent sending empty messages
      append({
        role: 'user',
        content: [
          {
            type: 'text',
            text: input,
          },
        ],
        id: nanoid(),
        createdAt: new Date().toISOString(),
      });
      setInput('');
    }

    return (
      <div className="flex items-center justify-between w-full">
        <input
          ref={ref}
          type="text"
          value={input}
          className="border-0 w-full p-4 outline-none text-base"
          placeholder={isLoading ? 'Cargando...' : 'Escribe un mensaje'}
          onChange={handleInputChange}
          disabled={isLoading}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !error) submitMessage(e);
          }}
          name="chat-input"
          autoComplete="off"
        />
        <button type="submit" disabled={isLoading || !!error} className="px-3" onClick={(e) => submitMessage(e)}>
          <ChevronRightIcon
            height={32}
            className={`${error ? 'text-buttonDisabledColor cursor-not-allowed' : 'cursor-pointer'}`}
            type="submit"
          />
        </button>
      </div>
    );
  },
);

ChatInputForm.displayName = 'ChatInputForm';
